export default __webpack_public_path__ + "assets/0635b1db2c546453a3ba7ae64c5bbc9d.jpeg";